module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-login-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sk-google-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.continueWithGoogle
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 48 48",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFC107",
      "d": "M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FF3D00",
      "d": "M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#4CAF50",
      "d": "M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#1976D2",
      "d": "M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"
    }
  })]), _vm._v("\n        Continue with Google\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "sk-google-hint"
  }, [_vm._v("Signed up with Google? Use Continue with Google, or "), _c('router-link', {
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v("reset your password")]), _vm._v(".")], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-or"
  }, [_vm._v("or log in with email")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "sk-input",
    attrs: {
      "type": "email",
      "placeholder": "you@company.com",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-row sk-mt-4"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-opts sk-mt-4"
  }, [_c('router-link', {
    staticClass: "sk-forgot-link",
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v("Forgot password?")])], 1), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-4",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.working
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v("Log In →")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Don't have an account? "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up free")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Log in to your account")]), _vm._v(" "), _c('p', [_vm._v("Welcome back. Enter your credentials to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f1be5e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/LoginPage.vue
// module id = 782
// module chunks = 2